export const PROFILE_VERIFICATION_STATE_KEY = 'profileVerification'

export const CONTENT_LOAD = 'Casino/ProfileVerification/CONTENT_LOAD'
export const CONTENT_LOAD_SUCCESS = 'Casino/ProfileVerification/CONTENT_LOAD_SUCCESS'
export const CONTENT_LOAD_ERROR = 'Casino/ProfileVerification/CONTENT_LOAD_ERROR'
